import {showErrorMessage, showToast} from "../../ui/ui";

export function downloadFile(url, fileName, errorMessage = null, successMessage = null) {
    fetch(url)
        // check to make sure you didn't have an unexpected failure (may need to check other things here depending on use case / backend)
        .then(resp => resp.status === 200 ? resp.blob() : Promise.reject('something went wrong'))
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            // the filename you want
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            // or you know, something with better UX...
            if (successMessage !== null) {
                showToast(successMessage);
            }
        })
        .catch(() => {
            if (errorMessage !== null) {
                showErrorMessage(errorMessage);
            }
        });
}

export function downloadImageImageDataURLAsPDF(imageDataURL, fileName) {

    fetch('/configurator/download-image-as-pdf', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') // Ensure you include CSRF token for Laravel
        },
        body: JSON.stringify({image: imageDataURL, fileName: fileName})
    })
        .then(response => response.blob())
        .then(blob => {
            // Create a URL for the blob
            const url = window.URL.createObjectURL(blob);
            // Create a new anchor element
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        })
        .catch(error => console.error('Error:', error));

}


export function downloadImageDirectly(imageDataURL, fileName) {
    //replace filename extension to png
    fileName = fileName.replace(/\.[^/.]+$/, ".png");
    fetch('/configurator/download-image', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') // Ensure you include CSRF token for Laravel
        },
        body: JSON.stringify({image: imageDataURL, fileName: fileName})
    })
        .then(response => response.blob())
        .then(blob => {
            // Create a URL for the blob
            const url = window.URL.createObjectURL(blob);
            // Create a new anchor element
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        })
        .catch(error => console.error('Error:', error));

}
